import { useEffect, useState } from "react";

import { getPromotionById } from "@api/initiatePromotion";
import {
  PromotionDataType,
  PromotionDetailsType,
  RecommendationType,
} from "@type/HRM/promotions";

export const usePromotion = (id: string) => {
  const [data, setData] = useState<any>([]);

  const handleUpdate = (promotionData: PromotionDetailsType) => {
    setData((prevData: PromotionDataType) => ({
      ...prevData,
      promotionDetails: prevData.promotionDetails.map(
        (obj: PromotionDetailsType) =>
          obj.promotionDetailsId === promotionData.promotionDetailsId
            ? {
                ...obj,
                ...promotionData,
              }
            : obj,
      ),
    }));
  };

  const handleRecommendation = (recommendation: RecommendationType) => {
    setData((prevData: PromotionDataType) => ({
      ...prevData,
      promotionDetails: prevData.promotionDetails.map(
        (obj: PromotionDetailsType) =>
          obj.promotionDetailsId === recommendation.promotionDetailsId
            ? {
                ...obj,
                recommendation,
              }
            : obj,
      ),
    }));
  };

  const handleDelete = (promotionDetailsId: number) => {
    setData((prevData: PromotionDataType) => ({
      ...prevData,
      promotionDetails: prevData.promotionDetails.filter(
        (obj: PromotionDetailsType) =>
          obj.promotionDetailsId !== promotionDetailsId,
      ),
    }));
  };

  const handleUpdatePromotionGroup = (
    promotionDetails: PromotionDetailsType[],
  ) => {
    setData((prevData: PromotionDataType) => ({
      ...prevData,
      promotionDetails: [...prevData.promotionDetails, ...promotionDetails],
    }));
  };

  useEffect(() => {
    if (id) {
      getPromotionById(id)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [id]);

  return {
    data,
    handleUpdate,
    handleDelete,
    handleRecommendation,
    handleUpdatePromotionGroup,
  };
};
